import { Anchor, Box, Breadcrumbs, Container, Stack, Text, Title } from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/legal/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <Box style={{ minHeight: '100vh' }}>
      <Container size="md" py="xl">
        <Breadcrumbs mb="lg">
          <Anchor component={Link} to="/" c="dimmed">
            Home
          </Anchor>
          <span>Kebijakan Privasi</span>
        </Breadcrumbs>
        <Stack gap="md">
          <Title order={1}>Kebijakan Privasi</Title>
          <Text c="dimmed" size="sm">
            Efektif: 1 Januari 2026 · Sesuai UU Perlindungan Data Pribadi (UU PDP)
          </Text>
          <Title order={3}>1. Data yang Dikumpulkan</Title>
          <Text>
            Kami mengumpulkan: informasi akun (nama, email), data operasional marina (customer, booking, invoice), dan
            log akses. Tidak ada data biometrik atau kesehatan.
          </Text>
          <Title order={3}>2. Penyimpanan</Title>
          <Text>
            Data disimpan di server Indonesia (Jakarta) dengan enkripsi AES-256 at-rest dan TLS 1.3 in-transit. Backup
            harian retained 30 hari.
          </Text>
          <Title order={3}>3. Akses</Title>
          <Text>
            Hanya personel yang diotorisasi dengan kebutuhan operasional. Semua akses dicatat di audit log yang dapat
            Anda lihat di Settings → Audit Log.
          </Text>
          <Title order={3}>4. Sharing Pihak Ketiga</Title>
          <Text>
            Data tidak dijual. Sharing hanya ke penyedia layanan pembayaran (Midtrans/Xendit/QRIS) saat transaksi,
            dengan kontrak DPA.
          </Text>
          <Title order={3}>5. Hak Anda</Title>
          <Text>
            Sesuai UU PDP, Anda berhak: akses, perbaikan, penghapusan, portabilitas. Kirim permintaan ke{' '}
            <Anchor href="mailto:privacy@open-marina.id">privacy@open-marina.id</Anchor>.
          </Text>
          <Title order={3}>6. Cookies</Title>
          <Text>
            Kami menggunakan cookies sesi untuk autentikasi saja. Tidak ada cookies tracking pihak ketiga tanpa consent.
          </Text>
          <Text c="dimmed" size="xs" mt="xl">
            Dokumen placeholder. Draft final dipublikasikan setelah review legal.
          </Text>
        </Stack>
      </Container>
    </Box>
  )
}
